module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Black.a60431b.otf";